import { RegisteredApplicationDto } from 'api/NSwagApi/api'

export const sortByApplicationName = (applications: RegisteredApplicationDto[]): RegisteredApplicationDto[] =>
  applications.sort((a, b) => (a.applicationName?.toLowerCase() || '').localeCompare(b.applicationName?.toLowerCase() || ''));

export const getLocalDateTimeFromUtc = (utcInput: any) => {
  if(utcInput){
    const utcDateTime = new Date(utcInput).toString();
    const localDateTime = new Date(utcDateTime + 'UTC');
    const localeDateTimeString = localDateTime.toLocaleString();
    return localeDateTimeString;
  }
  return '--';
};